export default __webpack_public_path__ + "static/media/menu-stats-white.e2e2f646.svg";